import React from 'react'

import { useSession } from '../../../contexts/session-context'
import useTherapists from '../../../hooks/useTherapists'
import DiagnosisTeaserContent from './DiagnosisTeaserContent'

type DiagnosisTeaserV2Props = {
  readonly className?: string
  readonly vertical?: boolean
  readonly title?: string
}

const DiagnosisTeaserPageRouter: React.FC<DiagnosisTeaserV2Props> = ({ className, vertical = false, title }) => {
  const { isLoggedIn } = useSession()
  const { therapists } = useTherapists('all')

  return (
    <DiagnosisTeaserContent
      therapists={therapists}
      vertical={vertical}
      className={className}
      isLoggedIn={isLoggedIn}
      title={title}
    />
  )
}

export default DiagnosisTeaserPageRouter
